import * as React from 'react';

const styles = require('./index.css');

export const IconFsk = () => <div className={styles['fsk']} />;
